import { SsoGroupRuleView } from '@evidentid/tprm-portal-lib/models/sso-provisioning';

export interface RulesValidation {
    // The message the API would answer with (same wording, same precedence), or null when valid.
    message: string | null;
    // Per-row hint for the rows that cause a blank or duplicate failure.
    rowErrors: (string | null)[];
}

const normalize = (id: string): string => id.trim().toLowerCase();

// Mirrors SsoProvisioningRoute.validateRules in eid-insurance: IDs are compared trimmed and
// case-insensitively; blank, then duplicate, then "no Admin rule with a non-blank ID".
export function validateRules(rules: SsoGroupRuleView[]): RulesValidation {
    const ids = rules.map((rule) => normalize(rule.groupObjectId));
    const rowErrors = ids.map((id, index): string | null => {
        if (id === '') {
            return 'Enter the group object ID.';
        }
        return ids.indexOf(id) !== index || ids.lastIndexOf(id) !== index ? 'This group is already mapped.' : null;
    });

    if (ids.some((id) => id === '')) {
        return { message: 'A group ID must not be blank.', rowErrors };
    }
    if (new Set(ids).size !== ids.length) {
        return { message: 'A group may map to only one role.', rowErrors };
    }
    if (!rules.some((rule) => rule.role === 'admin' && rule.groupObjectId.trim() !== '')) {
        return { message: 'At least one group must map to Admin.', rowErrors };
    }
    return { message: null, rowErrors };
}
